<template>
  <el-form :model="form" ref="form" :rules="rules">
    <el-form-item label="所属部门" prop="parent_id" label-width="120px">
      <el-cascader
          :options="branchesTree"
          v-model="parentSelected"
          :props="cascaderProps"
          change-on-select
          placeholder="请选择所属部门"
          style="width:100%"
      >
      </el-cascader>
    </el-form-item>

    <el-form-item label="部门名称" prop="name" label-width="120px">
      <el-input v-model="form.name" placeholder="请输入内容"></el-input>
    </el-form-item>
    <el-form-item label="部门级别" prop="level" label-width="120px">
      <el-select v-model="form.level" placeholder="请选择">
        <el-option label="一级部门" value="1"></el-option>
        <el-option label="二级部门" value="2"></el-option>
        <el-option label="小组" value="3"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="部门负责人" prop="leader_uid" label-width="120px">
      <el-select v-model="form.leader_uid" filterable placeholder="请选择" label-width="120px">
        <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="设为业务部门" prop="is_business" label-width="120px">
      <el-switch
          active-color="#409EFF"
          inactive-color="#ff4949"
          v-model="form.is_business"
      >
      </el-switch>
    </el-form-item>

    <el-form-item label="备注" prop="memo" label-width="120px">
      <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          v-model="form.memo"
      >
      </el-input>
    </el-form-item>

    <el-form-item v-if="form.id == 0" label-width="120px">
      <el-button type="primary" :loading="submiting" @click="submitForm()">立即保存</el-button>
    </el-form-item>
    <el-form-item v-else label-width="120px">
      <el-button type="primary" :loading="submiting" @click="submitForm()">保存更新</el-button>
      <el-button type="danger" :loading="submiting" @click="handleDelete(form.id)">删除部门</el-button>
    </el-form-item>

  </el-form>
</template>

<script>
import {BranchService, BranchModel} from "~/services/Branch";
import UserService from "~/services/user";
export default {
  name: "BranchForm",
  props: {
    // 部门列表树结构
    branchesTree: {
      type: Array,
      required: true
    },
    branchInfo: {
      type: Object,
      required: false,
      value: function () {
        return null;
      }
    }
  },
  data: function () {
    return {
      users: [],
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'childs'
      },
      parentSelected: ["0"], // 当前选择的上级部门
      form: {},
      rules: {
        parent_id: [
          {
            required: true,
            message: "请选择所属部门"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入部门名称"
          }
        ],
        leader_uid: [
          {
            required: true,
            message: "请选择部门负责人",
            trigger: "change"
          }
        ],
        level: [
          {
            required: true,
            message: "请选择部门等级",
            trigger: "change"
          }
        ]
      },
      submiting: false
    }
  },
  created: function () {
    this.getSelectOptions();
    // 编辑状态
    if (this.branchInfo != null && parseInt(this.branchInfo.id) > 0) {
      this.getInfo(this.branchInfo.id);
    } else {
      // 新增创建状态
      this.form = BranchModel;
    }
  },
  watch: {
    // 监听表单中级联选择器的当前选择然后取最后一级
    parentSelected: function (value, original) {
      if (value.length > 0) {

        for (var key in value) {
          value[key] = value[key].toString();
        }
        // 取最后一级
        this.form.parent_id = value[value.length - 1].toString();
      } else {
        this.form.parent_id = null;
      }
    },

    branchInfo: function (value, original) {
      if (value != null && parseInt(value.id) > 0) {
        this.getInfo(value.id);
      }
    }
  },
  methods: {

    /**
     * 获取部门信息
     * @param branchId
     */
    getInfo(branchId) {
      BranchService.getBranchInfo(branchId).then(res => {
        if (res && res.code == 0) {
          let branch = res.data;
          this.form = branch;
          this.form.level = branch.level.toString();
          this.form.parent_id = branch.parent_id.toString();
          this.parentSelected = branch.parent_path;
        }
      })
    },

    /**
     * 提交表单内容
     */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.submiting = true;
          // 发起创建
          if (parseInt(this.form.id) == 0) {
            BranchService.create(this.form)
                .then(res => {
                  this.submiting = false;
                  if (res.code == 0 && res.data) {
                    this.$message({
                      type: "success",
                      message: "创建成功！"
                    });
                    this.parentSelected = [];
                    this.$refs["form"].resetFields();
                    this.form.name = '';
                    this.$emit("saveCallback", res.data);
                  }
                })
                .catch(err => {
                  this.submiting = false;
                  console.error(err);
                });
          } else {
            // 发起更新
            BranchService.update({
              id: this.form.id,
              name: this.form.name,
              parent_id: this.form.parent_id,
              is_business: this.form.is_business,
              memo: this.form.memo,
              leader_uid: this.form.leader_uid,
              level: this.form.level,
            }).then(res => {
              this.submiting = false;
              if (res && res.data) {
                this.submiting = false;
                this.$message({
                  type: "success",
                  message: "更新成功！"
                });
                //this.parentSelected = [];
                this.$refs["form"].resetFields();
                this.$emit("saveCallback", res.data);
              }
            }).catch(err => {
              this.submiting = false;
              console.error(err);
            });
          }
        }
      });
    },

    handleDelete(branchId) {
      if (parseInt(branchId) <= 0) {
        return;
      }

      this.$confirm("确定要删除 "+ this.form.name +" ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        BranchService.delete(branchId).then(res => {
          if (res && res.code == 0) {
            this.$message({
              type: "success",
              message: "执行成功!"
            });

            location.reload();
          }
        });
        return true;
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消执行"
        });
        return false;
      });

    },

    getSelectOptions() {
      UserService.getAll({
        fields: "id,name",
        scenario: "all-user"
      }).then(res => {
        if (res.code == 0) {
          this.users = res.data
        }
      })

    },
  }
}
</script>


// WEBPACK FOOTER //
// src/views/branch/form.vue